<template>
	<div class="page">
		<Head1 :titleVal="$t('components.head1.title.login')"></Head1>
		<div>
			<div class="tabArea">
				<div class="tabLi" :class="selectedTab == 0 ? 'active' : ''"  @click="tabClick(0)">{{$t('pages.login.tab1')}}</div>
				<div class="tabLi" :class="selectedTab == 1 ? 'active' : ''"  @click="tabClick(1)">{{$t('pages.login.tab2')}}</div>
			</div>
			<div v-if="selectedTab == 0" class="mainArea">
				<div class="label">{{$t('pages.login.phoneNumber')}}</div>
				<div class="inputArea">
					<input type="text" :placeholder="$t('pages.login.phonePlaceholder')" class="telInput" v-model="form.phoneNumber"/>
				</div>				
				<div class="label">{{$t('pages.login.verifyCode')}}</div>
				<div>
					<input type="text" class="codeInput" :placeholder="$t('pages.login.codePlaceholder')"  v-model="form.checkCode"/>
					<button class="codeBtn"  v-if="!isCountdown" @click="startCountdown(60)">{{$t('pages.login.getCode')}}</button>		
					<button class="codeBtn" v-if="isCountdown" disabled>{{$t('pages.login.reGetCCode', { time: countdown })}}</button>				
				</div>
				<div class="loginBtn" @click="checkcodeLogin()">{{$t('pages.login.loginBtn')}}</div>
				<router-link to="/register"><div class="registerBtn">{{$t('pages.login.register')}}</div></router-link>
			</div>
			<div v-if="selectedTab == 1" class="mainArea">
				<div class="label">{{$t('pages.login.phoneNumber')}}</div>
				<div class="inputArea">
					<input type="text" :placeholder="$t('pages.login.phonePlaceholder')" class="telInput"  v-model="form.loginName" id="userName"/>
				</div>
				<div class="label">{{$t('pages.login.password')}}</div>
				<input type="password" :placeholder="$t('pages.login.passwordPlaceholder')" class="telInput"  id="password" v-model="form.loginPwd"/>
				<div class="loginBtn" @click="PsdLogin()">{{$t('pages.login.loginBtn')}}</div>
				<router-link to="/register"><div class="registerBtn">{{$t('pages.login.register')}}</div></router-link>
				<router-link to="/forget"><div class="forget">{{$t('pages.login.forgetPwd')}}</div></router-link>

			</div>
		</div>
		<Foot1></Foot1>
	</div>	
</template>

<script>
	import Head1 from '../components/head1.vue';
	import Foot1 from '../components/foot1.vue';

	export default{
		components:{
			Head1,
			Foot1
		},
		data() {
			return {
				titleStr: '登录',
				selectedTab:0,
				countdown: 0,
				isCountdown: false,
				form: {
				    loginName: '',
				    loginPwd: '',
					phoneNumber:'',
				    checkCode: ''
				},
			}			
		},
		created(){
			
			
		},
		methods: {
			tabClick(idx){
				this.selectedTab = idx;
			},
			PsdLogin() {
			    if (!this.form.loginName) {
					this.$message({ message: this.$t('pages.login.validation.phone_required'), type: 'warning' });
			        return;
			    }
			
			    if (!this.form.loginPwd) {
					this.$message({ message: this.$t('pages.login.validation.password_required'), type: 'warning' });
			        return;
			    }
			    this.$scUtil.axiosPost(this, 'loginapi/doLogin',
				{
					userName:this.form.loginName,
					pwd:this.form.loginPwd
				}
				, res => {
					console.log(JSON.stringify(res))
			        if (res.code == 100) {					
			            let loginToken = res.message;
						console.log(res.data.userId)
			            localStorage.setItem('logintoken', "Bearer "+loginToken);
						localStorage.setItem('username',res.data.userId);
			            this.$router.push({ name: "IndexVue" });
			        }
			        else {
			            this.$message(res.message);
			        }
			    });
			},
			startCountdown(seconds) {		
				this.$scUtil.axiosPut(this, 'CommonApi/Execute', {
					cellphone: this.form.phoneNumber,
					operate: 'getVcode',
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.$message({message: res.message,type: "success"});
						this.isCountdown = true;
						this.countdown = seconds;
						const interval = setInterval(() => {
							if (this.countdown > 0) {
							this.countdown -= 1;
							} else {
							clearInterval(interval);
							this.isCountdown = false;
							}
						}, 1000);
					}else
					{
						this.$message({message: res.message,type: "warning"});
					}
			
				});
			  
			},
			checkcodeLogin() {
			    if (!this.form.phoneNumber) {
					this.$message({ message: this.$t('pages.login.validation.phone_required'), type: 'warning' });
			        return;
			    }
			
			    if (!this.form.checkCode) {
					this.$message({ message: this.$t('pages.login.validation.code_required'), type: 'warning' });
			        return;
			    }
				console.log(this.form.phoneNumber);
			    this.$scUtil.axiosPost(this, 'loginapi/doLoginCheckCode',
				{
					phoneNumber:this.form.phoneNumber,
					checkCode:this.form.checkCode
				}
				, res => {
					console.log(JSON.stringify(res))
			        if (res.code == 100) {					
			            let loginToken = res.message;
						console.log(res.data.userId);
			            localStorage.setItem('logintoken', "Bearer "+loginToken);
						localStorage.setItem('username',res.data.userId );
			            this.$router.push({ name: "IndexVue" });
			        }
			        else {
			            this.$message(res.message);
			        }
			    });
			},
		}
	}
</script>

<style scoped>
	.page{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.tabArea{
		width: 829px;
		display: flex;
		align-items: center;
		margin-top: 58px;
	}
	
	.tabLi{
		border-bottom: 2px solid #d8d8d8;
		flex: 1;
		text-align: center;
		font-size: 24px;
		color: #888888;
		font-weight: bolder;
		height: 68px;
		line-height: 68px;
		cursor: pointer;
	}
	
	.tabLi.active{
		color: #0380fe;
		border-bottom: 2px solid #0380fe;
	}
	
	.label{
		font-size: 15px;
		color: #333333;
		width: 415px;
		text-align: left;
		margin-bottom:  16px;
	}
	
	.telInput{
		width: 415px;
		height: 50px;
		border: 1px solid #cdcdcd;
		padding: 0 11px;
		font-size: 13px;
		color: #000;
		box-sizing: border-box;
	}
	
	.telInput::placeholder,
	.codeInput::placeholder{
	  color: #888888;
	  font-size: 13px;
	}
	
	.loginBtn{
		width: 415px;
		height: 53px;
		text-align: center;
		line-height: 53px;
		background-color: #0380fe;
		border: 1px solid #0380fe;
		color: #fff;
		font-size: 20px;
		margin-top:47px;
		cursor: pointer;
	}
	
	.registerBtn{
		width: 415px;
		height: 53px;
		text-align: center;
		line-height: 53px;
		color: #0380fe;
		border: 1px solid #0380fe;
		font-size: 20px;
		margin-top:23px;
		cursor: pointer;
	}
	
	.mainArea{
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-top: 49px;
		padding-bottom: 130px;
	}
	
	.inputArea{
		margin-bottom:35px;
	}
	
	.codeBtn{
		width: 140px;
		height: 49px;
		border: 1px solid #0380fe;
		color: #333333;
		font-size: 14px;
		background-color: #fff;
		cursor: pointer;
	}
	
	.codeInput{
		width: 262px;
		height: 49px;
		border:1px solid #cdcdcd;
		margin-right:13px;
		padding: 0 11px;
		box-sizing: border-box;
	}
	
	input:focus{
		outline: none;
	}
	
	.forget{
		width: 415px;
		text-align: right;
		font-size: 13px;
		color: #888888;
		margin-top: 25px;
	}
</style>